// extracted by mini-css-extract-plugin
export default {"root":"photo_root__VeHQv","picture":"photo_picture__EYghy","placeHolderShimmer":"photo_placeHolderShimmer__t3Ys0"};